export const QUESTIONNAIRE = [
  {
    title: "Pelle e corpo",
    questions: [
      { key: "skin_type", label: "Che tipo di pelle ha?", type: "radio", options: ["Normale", "Secca", "Grassa", "Mista", "Sensibile", "Non so"] },
      { key: "concerns", label: "Quali inestetismi vorrebbe trattare?", type: "multi", options: ["Rughe e segni d'espressione", "Macchie", "Acne / impurità", "Pori dilatati", "Rossori / couperose", "Cellulite", "Ritenzione idrica", "Adiposità localizzata", "Peli superflui", "Smagliature", "Rilassamento cutaneo"] },
      { key: "sensitivity", label: "La sua pelle reagisce facilmente (arrossamenti, prurito)?", type: "radio", options: ["Sì", "A volte", "No"] },
    ],
  },
  {
    title: "Salute e anamnesi",
    questions: [
      { key: "allergies", label: "Ha allergie note (cosmetici, metalli, farmaci, lattice)?", type: "text", placeholder: "Es. nichel, profumi…" },
      { key: "medications", label: "Assume farmaci o integratori?", type: "text", placeholder: "Specificare" },
      { key: "conditions", label: "Ha o ha avuto una di queste condizioni?", type: "multi", options: ["Problemi circolatori / vene varicose", "Diabete", "Pressione alta", "Problemi cardiaci / pacemaker", "Patologie della tiroide", "Malattie della pelle", "Epilessia", "Protesi metalliche"] },
      { key: "pregnancy", label: "È in gravidanza o allattamento?", type: "radio", options: ["Sì", "No", "Non applicabile"] },
      { key: "recent_procedures", label: "Ha fatto di recente interventi, filler, peeling o laser?", type: "text", placeholder: "Quando e quale" },
    ],
  },
  {
    title: "Abitudini e stile di vita",
    questions: [
      { key: "skincare_routine", label: "Che prodotti usa abitualmente a casa?", type: "textarea", placeholder: "Detergente, crema, siero…" },
      { key: "sun_exposure", label: "Quanto si espone al sole o a lampade?", type: "radio", options: ["Spesso", "Ogni tanto", "Raramente"] },
      { key: "smoker", label: "Fuma?", type: "radio", options: ["Sì", "No"] },
      { key: "water", label: "Quanta acqua beve al giorno?", type: "radio", options: ["Meno di 1 litro", "1–2 litri", "Più di 2 litri"] },
      { key: "sleep_stress", label: "Come valuta sonno e stress?", type: "radio", options: ["Dormo bene, poco stress", "Nella media", "Dormo poco / molto stress"] },
      { key: "sport", label: "Pratica attività fisica?", type: "radio", options: ["Regolarmente", "Ogni tanto", "Mai"] },
    ],
  },
  {
    title: "Obiettivi e preferenze",
    questions: [
      { key: "goals", label: "Qual è il suo obiettivo principale?", type: "textarea", placeholder: "Cosa desidera ottenere dai trattamenti" },
      { key: "interests", label: "Quali trattamenti le interessano?", type: "multi", options: ["Viso", "Corpo", "Massaggi", "Epilazione", "Mani e piedi", "Ciglia e sopracciglia", "Make-up", "Percorsi relax"] },
      { key: "frequency", label: "Con che frequenza pensa di venire?", type: "radio", options: ["Settimanale", "Ogni 2 settimane", "Mensile", "Occasionale"] },
      { key: "how_found", label: "Come ci ha conosciuto?", type: "radio", options: ["Passaparola", "Social", "Google", "Passando davanti", "Altro"] },
      { key: "privacy_consent", label: "Consenso al trattamento dei dati personali e sanitari", type: "radio", options: ["Acconsento", "Non acconsento"] },
    ],
  },
];

export const ALL_QUESTIONS = QUESTIONNAIRE.flatMap((s) => s.questions);
